import { defineStore } from 'pinia'
import { reloadPage, hideShowFullSpinner } from 'src/utils'
import { useGuestStore } from 'src/stores/guest'
import { useAuthStore } from 'src/stores/auth'
import { useShowCaseStore } from 'src/stores/showcase'
import { useCartStore } from 'src/stores/cart'
import { usePersistedStore } from 'src/stores/persisted'

export const useLocationStore = defineStore('location', {
  state: () => ({
    currentLocationDetail: null,
    latitude: null,
    longitude: null,
    milesOptions: [
      {
        label: 'All',
        val: '0',
      },
      {
        label: '5 Miles',
        val: '5',
      },
      {
        label: '10 Miles',
        val: '10',
      },
      {
        label: '15 Miles',
        val: '15',
      },
      {
        label: '20 Miles',
        val: '20',
      },
      {
        label: '25 Miles',
        val: '25',
      },
      {
        label: '25+ Miles',
        val: '-1',
      },
    ],
    toLocationNFulfillment: null,
    changeLocationCartDetail: null,
    changeLocationAndAddToCart: null,
  }),
  actions: {
    async searchLocation(params) {
      try {
        let { data } = await this.$axiosInstance.get('/location', { params })
        return data
      } catch (error) {
        return false
      }
    },
    async verifyShipping(params) {
      try {
        let { data } = await this.$axiosInstance.get('/Location/Shipping', {
          params,
        })
        return data
      } catch (error) {
        return error
      }
    },
    async getMyLocation(params) {
      try {
        let { data } = await this.$axiosInstance.get(
          '/Location/SearchLocation',
          {
            params,
          }
        )
        return data
      } catch (error) {}
    },
    async applyChangeLocation(body) {
      const guestStore = useGuestStore()
      try {
        let { data } = await this.$axiosInstance.put(
          '/Cart/ApplyChangeLocation',
          {},
          { params: body }
        )

        if (this.changeLocationCartDetail?.availableProductsCount == 0) {
          guestStore.setGuestCartNumber(null)
          guestStore.setGuestUser({ guestUser: null })
        }
        return data
      } catch (error) {
        return false
      }
    },
    async setAsMyStore({
      location,
      fulfillment,
      selectedZipCode,
      deliveryAddress = null,
      forceCompare = false,
      forceReload = true,
      redirectFrom = '',
    }) {
      const showCaseStore = useShowCaseStore()
      const guestStore = useGuestStore()
      const authStore = useAuthStore()
      const cartStore = useCartStore()
      const persistedStore = usePersistedStore()

      hideShowFullSpinner(true)

      let isLoggedIn = authStore.isLoggedIn
      if (!isLoggedIn) {
        let currentLocationId = persistedStore.currentLocationId
        if (location.locationId != currentLocationId)
          guestStore.resetSlots(null)
      }

      if (
        forceCompare ||
        (cartStore.currentCartDetails && cartStore.currentCartDetails.orderID)
      ) {
        try {
          let fulfillmentId =
              fulfillment?.fulfillmentID ||
              fulfillment?.fulfillmentId ||
              fulfillment?.fulfillmentMethodID ||
              '',
            guestCartNumber = guestStore.guestCartNumber,
            params = {
              locationId: location.locationId,
              fulfillmentMethodID: fulfillmentId,
              zipCode:
                fulfillment.codeName === 'sd'
                  ? location.customerZip
                  : location.address?.zip,
            }
          if (!isLoggedIn && guestCartNumber)
            params.orderNumber = guestCartNumber

          let { data } = await this.$axiosInstance.get(
            '/Cart/ChangeLocationDetail',
            { params }
          )

          if (data.success) {
            this.changeLocationCartDetail = data.data
          }
        } catch (error) {}

        this.toLocationNFulfillment = {
          location,
          fulfillment,
          selectedZipCode,
          deliveryAddress,
        }
        showCaseStore.updateDialogState({
          dialog: 'ChangeLocationConfirm',
          val: true,
          // parentDialog: 'changeLocation',
        })
      } else {
        await persistedStore.setServiceLocation({
          location,
          fulfillment,
          selectedZipCode,
          deliveryAddress,
        })

        if (this.changeLocationAndAddToCart)
          await cartStore
            .addUpdateCartDetail(this.changeLocationAndAddToCart)
            .then(() => (this.changeLocationAndAddToCart = null))

        if (forceReload) {
          reloadPage(redirectFrom || '/')
        }
      }
      hideShowFullSpinner(false)
    },
    async getAvailableNearByStoreDetails(params) {
      try {
        let { data } = await this.$axiosInstance.get(
          '/Location/NearByStoreDetails',
          { params }
        )
        return data
      } catch (error) {}
    },
    setCurrentLocationDetail(data) {
      this.currentLocationDetail = data
    },
    setChangeLocationCartDetail(data) {
      this.changeLocationCartDetail = data
    },
    setToLocationNFulfillment(data) {
      this.toLocationNFulfillment = data
    },
    setChangeLocationAndAddToCart(data) {
      this.changeLocationAndAddToCart = data
    },
    setLatLng(lat, lng) {
      this.latitude = lat
      this.longitude = lng
    },
  },
})
